import anime from 'animejs';
import AddToWishlist from 'components/add-to-wishlist/AddToWishlist';
import Form from 'components/form/Form';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import { sendProductForm } from 'helpers/addToCartButton';
import store from 'store';
import { defer } from 'lodash-es';
class ProductCard extends Component {
    url;
    _currentImage = 0;
    fraction = 0;
    animation;
    _switching = false;
    eventSent = false;
    io;
    get switching() {
        return this._switching;
    }
    set switching(value) {
        this._switching = value;
        this.refs.slider.classList.toggle('switching', value);
    }
    get currentImage() {
        return this._currentImage;
    }
    set currentImage(value) {
        this._currentImage = value;
        if (this.refs.prevImage)
            this.refs.prevImage.classList.toggle('disabled', value === 0);
        if (this.refs.nextImage)
            this.refs.nextImage.classList.toggle('disabled', value === this.refs.images.length - 1);
    }
    getModuleParams(el, componentConstructor) {
        return {
            parent: this.parent?.parent || this.parent
        };
    }
    getModulesMap() {
        return {
            addToWishlist: ['.add-to-wishlist', AddToWishlist],
            addToCartForm: ['.add-to-cart__form', Form]
        };
    }
    initialized() {
        super.initialized();
        defer(() => {
            if (this.refs.slider)
                this.fraction = this.refs.slider.scrollWidth / this.refs.images.length;
            // if (this.el.querySelector('video')) {
            this.io = new IntersectionObserver(this.inViewUpdate.bind(this), { rootMargin: '-50px 0px 0px 0px' });
            const video = this.el.querySelector('video');
            if (video)
                this.io.observe(video);
            // }
        });
    }
    inViewUpdate(entries) {
        for (let i = 0; i < entries.length; i++) {
            const video = entries[i].target;
            try {
                if (entries[i].isIntersecting) {
                    this.resize();
                    video.play();
                }
                else {
                    video.pause();
                }
            }
            catch (e) {
                console.warn('Error playing video', e); // eslint-disable-line no-console
            }
        }
    }
    bindEvents = (add) => {
        const method = bindMethod(add);
        const emitterMethod = bindEmitterMethod(add);
        if (this.refs.prevImage && this.refs.nextImage) {
            this.refs.prevImage[method]('click', (e) => this.navigateImage(e, -1));
            this.refs.nextImage[method]('click', (e) => this.navigateImage(e, 1));
        }
        if (this.refs.slider)
            this.refs.slider[method]('scroll', this.onScroll);
        if (this.modules.addToWishlist)
            this.modules.addToWishlist[emitterMethod]('toggle', this.onToggleWishlist);
        if (this.refs.addToCartButton)
            this.refs.addToCartButton[method]('click', this.addToCart);
        if (this.refs.deleteAlertButton)
            this.refs.deleteAlertButton[method]('click', this.onDeleteAlert);
        this.el[method]('click', this.onClick);
    };
    onClick = (e) => {
        const event = { ...e };
        event.currentTarget = this.el;
        this.emit('click', event);
        const id = this.el.getAttribute('data-id');
        store.lastProduct.set(id);
    };
    onToggleWishlist = (e) => {
        this.emit('wishlist:toggle', e);
    };
    onDeleteAlert = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.modules.addToCartForm.submit();
    };
    navigateImage = async (event, direction) => {
        event.preventDefault();
        event.stopPropagation();
        const nextImageIndex = this.currentImage + direction;
        if (nextImageIndex < 0 || nextImageIndex >= this.refs.images.length)
            return;
        const options = {
            scrollLeft: this.refs.slider.scrollLeft
        };
        this.switching = true;
        if (this.animation)
            this.animation.pause();
        this.animation = anime({
            targets: options,
            scrollLeft: nextImageIndex * this.fraction,
            easing: 'easeOutQuad',
            update: () => {
                this.refs.slider.scrollLeft = options.scrollLeft;
                const progress = options.scrollLeft / (this.refs.slider.scrollWidth - this.refs.slider.clientWidth);
                this.refs.track.style.transform = `translateX(${progress * (100) * (this.refs.images.length - 1)}%)`;
            },
            duration: 225
        });
        this.animation.finished.then(() => {
            this.switching = false;
        });
        this.currentImage = nextImageIndex;
    };
    onScroll = (e) => {
        if (this.switching)
            return;
        this.fraction = this.refs.slider.scrollWidth / this.refs.images.length;
        const currentImage = Math.round(this.refs.slider.scrollLeft / this.fraction);
        const progress = this.refs.slider.scrollLeft / (this.refs.slider.scrollWidth - this.refs.slider.clientWidth);
        this.currentImage = currentImage;
        this.refs.track.style.transform = `translateX(${progress * (100) * (this.refs.images.length - 1)}%)`;
    };
    resize() {
        if (this.refs.slider)
            this.fraction = this.refs.slider.scrollWidth / this.refs.images.length;
        super.resize();
    }
    addToCart = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        sendProductForm({
            submitter: this.refs.addToCartButton,
            form: this.modules.addToCartForm,
            callback: this.onAddToCart
        });
    };
    onAddToCart = ({ data, xhr }) => {
        if (!data.error) {
            this.emit('add-to-cart', {
                xhr
            });
        }
    };
}
export default ProductCard;
